import { Button } from "components/atoms/button/button";
import styled from "styled-components";

export const ModalBody = styled.div`
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
`;

export const Heading = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  font-weight: 700;
  line-height: 42px;
  text-align: center;
`;

export const Description = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  color: ${({ theme }) => theme.colors.neutral[700]};
  text-align: center;
`;

export const RemainingTimeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  box-shadow: 0px 4px 32px 0px rgba(114, 131, 158, 0.2);
  border-radius: 8px;
  padding: 16px;
`;

export const RemainingTimeWrapper = styled.div`
  padding: 12px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.yellow[100]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  font-weight: 700;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Timer = styled.div`
  color: ${({ theme }) => theme.colors.brand[500]};
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TimerHighlight = styled.div`
  padding: 4px;
  background-color: ${({ theme }) => theme.colors.yellow[200]};
  border-radius: 4px;
`;

export const CloseCTA = styled(Button)`
  width: 320px;
  margin: auto;
`;
